/**
 * Quality badge — a small colored dot indicating quality tier (M3.3a C2).
 * Color-coded: grey/white/green/blue/purple for Poor→Masterwork.
 */

import type { Quality } from '../wire';
import { QUALITY_COLORS } from './quality';
import styles from './inventory.module.css';

export interface QualityBadgeProps {
  quality: Quality;
}

export function QualityBadge({ quality }: QualityBadgeProps): JSX.Element {
  return (
    <span
      className={styles.qualityBadge}
      style={{ backgroundColor: QUALITY_COLORS[quality] }}
      title={quality}
      data-testid="quality-badge"
      data-quality={quality}
    />
  );
}
